export default __webpack_public_path__ + "static/media/work1image3.ec8fa260.png";